<template>
  <v-container>
    <v-container>
      <h1 class="container-title">{{ location.name }}</h1>
    </v-container>
    <v-container>
      <v-card tile>
        <v-card-title>
          <span class="container-wide-screen">{{ $t("BASchedule") }}</span>

          <v-btn
            icon
            class="ml-3"
            @click="changeFilter()"
            :title="$t('reloadSummary')"
          >
            <v-icon>mdi-reload</v-icon>
          </v-btn>

          <v-btn icon @click.stop="dialogForm = true" :title="$t('BAFormBook')">
            <v-icon>mdi-plus-circle</v-icon>
          </v-btn>
          <booking-admin-form
            :selectedDay="selectedDay"
            :dialogForm="dialogForm"
            @close-form="dialogForm = false"
            @close-dialog="closeDialog"
            @visible-alert="visibleAlert"
          >
          </booking-admin-form>

          <v-btn
            icon
            @click.stop="dialogFormMulti = true"
            :title="$t('BAFormBookMulti')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M2 12c0-2.8 1.6-5.2 4-6.3V3.5C2.5 4.8 0 8.1 0 12s2.5 7.2 6 8.5v-2.2c-2.4-1.1-4-3.5-4-6.3m13-9c-5 0-9 4-9 9s4 9 9 9s9-4 9-9s-4-9-9-9m5 10h-4v4h-2v-4h-4v-2h4V7h2v4h4v2Z"
              />
            </svg>
          </v-btn>
          <v-dialog v-model="dialogFormMulti" persistent width="1400">
            <booking-admin-form-multi
              :selectedDay="selectedDay"
              :dialogFormMulti="dialogFormMulti"
              @close-form="dialogFormMulti = false"
              @close-dialog="closeDialog"
              @visible-alert="visibleAlert"
            >
            </booking-admin-form-multi>
          </v-dialog>

          <v-btn
            icon
            @click.stop="dialogSearch = true"
            :title="$t('navSearch')"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
          <search-modal
            :dialogSearch="dialogSearch"
            @close-modal="dialogSearch = false"
          >
          </search-modal>

          <v-btn
            v-if="location.id === 1"
            icon
            @click.stop="paymentForm = true"
            @reload-payments="false"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M15 15v2h3v3h2v-3h3v-2h-3v-3h-2v3m-3.03-3.39C14.85 10.28 13.59 8.97 12 9c-1.7.03-3 1.3-3 3s1.3 2.94 3 3c.38 0 .77-.08 1.14-.23c.27-1.1.72-2.14 1.83-3.16M13 16H7a2 2 0 0 0-2-2v-4c1.11 0 2-.89 2-2h10a2 2 0 0 0 2 2v.06c.67 0 1.34.12 2 .34V6H3v12h10.32a6.38 6.38 0 0 1-.32-2Z"
              />
            </svg>
          </v-btn>
          <payments-form
            :paymentForm="paymentForm"
            @close-dialog="paymentForm = false"
          ></payments-form>
        </v-card-title>
        <v-container class="py-0 px-3">
          <v-row>
            <v-col cols="12" sm="4" class="py-0">
              <v-menu
                v-model="menuDate"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formattedDate"
                    :label="$t('BASelectMonth')"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="selectedMonth"
                  type="month"
                  no-title
                  scrollable
                  @change="changeFilter()"
                  :locale="$i18n.locale"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="4" class="py-0">
              <v-menu
                v-model="menuPG"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="selectedPlayground ? selectedPlayground.name : ''"
                    :label="$t('BASelectPlayground')"
                    prepend-icon="mdi-home"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-list>
                  <v-list-item
                    v-for="playground in location.playgrounds"
                    :key="playground.id"
                    link
                    @click="changeFilter(playground)"
                  >
                    <v-list-item-title>{{ playground.name }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="4" class="py-0">
              <v-switch
                v-model="archive"
                inset
                color="red"
                :label="$t('BAShowArchieved')"
                dense
                @change="changeFilter()"
              ></v-switch>
            </v-col>
          </v-row>
        </v-container>

        <OrderInformationModal
          :alert="alert"
          @close-alert="alert = false"
        ></OrderInformationModal>

        <v-container>
          <v-expansion-panels v-if="summary.length" focusable v-model="panel">
            <v-expansion-panel
              v-for="(date, k) in summary"
              :key="k"
              @click="openSummaryItem(date)"
            >
              <v-expansion-panel-header>{{
                date.dateString
              }}</v-expansion-panel-header>
              <v-expansion-panel-content class="px-5 pb-2">
                <template v-if="Object.keys(groupedSchedule).length">
                  <v-sheet
                    v-for="(items, price) in groupedSchedule"
                    :key="price"
                  >
                    <v-card-title
                      class="headline px-0 pb-0"
                      v-html="price ? convertPrice(price) : $t('BAFree')"
                    ></v-card-title>
                    <v-row class="pt-2 pb-0" v-if="items.length">
                      <v-col
                        class="pa-2"
                        cols="12"
                        sm="3"
                        v-for="(sessionSlot, k) in items"
                        :key="k"
                      >
                        <booking-admin-item
                          :sessionSlot="sessionSlot"
                          :selectedDay="selectedDay"
                          @reload-schedule="openSummaryItem(date)"
                        ></booking-admin-item>
                      </v-col>
                    </v-row>
                  </v-sheet>
                </template>
                <template v-else>
                  <p class="red--text mb-0 mt-4">{{ $t("BANoSessions") }}</p>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <p v-else class="red--text ml-1">{{ $t("BANoDateSessions") }}</p>
        </v-container>
      </v-card>
    </v-container>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment"; // Remove?
import BookingAdminItem from "@/components/BookingAdminItem.vue";
import BookingAdminForm from "@/components/BookingAdminForm.vue";
import BookingAdminFormMulti from "@/components/BookingAdminFormMulti.vue";
import OrderInformationModal from "@/components/OrderInformationModal";
import SearchModal from "@/components/SearchModal";
import PaymentsForm from "@/components/PaymentsForm.vue";
import store from "../store";

export default {
  name: "BookingAdmin",

  beforeRouteEnter: async (to, from, next) => {
    await store.dispatch("loadLocation", to.params.location_id);
    next();
  },

  data: () => ({
    selectedMonth: moment().format("YYYY-MM"),
    menuDate: false,
    menuPG: false,
    selectedPlayground: null,
    alert: false,
    paymentForm: false,
    panel: null,
    archive: false,
    groupedSchedule: [],
    selectedDay: moment().toDate(),
    dialogForm: false,
    dialogFormMulti: false,
    dialogSearch: false,
  }),

  computed: {
    ...mapGetters(["location", "summary", "BASchedule", "orderId"]),
    formattedDate() {
      return this.selectedMonth
        ? moment(this.selectedMonth).format("MM.YYYY")
        : "";
    },
  },

  components: {
    SearchModal,
    BookingAdminItem,
    BookingAdminForm,
    BookingAdminFormMulti,
    OrderInformationModal,
    PaymentsForm,
  },

  methods: {
    ...mapActions(["loadSummary", "loadBASchedule"]),
    changeFilter(playground) {
      this.loadSummary({
        location_id: this.location.id,
        date: moment(this.selectedMonth).format("YYYY-MM"),
        with_archived: this.archive,
      });
      if (playground) {
        this.selectedPlayground = playground;
        window.localStorage.setItem("selected_pg_id", playground.id);
      }
      this.panel = null;
    },
    openSummaryItem(date) {
      let self = this;
      self.selectedDay = date.date;
      self
        .loadBASchedule({
          playground_id: self.selectedPlayground.id,
          selected_date: moment.parseZone(date.date).format("YYYY-MM-DD"),
        })
        .then(() => {
          let availableScheduleData = [];
          let maxPlayers = null;
          self.BASchedule.forEach((el) => {
            if (self.archive) {
              availableScheduleData.push(el);
            } else {
              if (
                !moment
                  .parseZone(el.begin)
                  .add(self.selectedPlayground.duration, "m")
                  .isBefore(moment.parseZone())
              ) {
                availableScheduleData.push(el);
                maxPlayers = self.selectedPlayground.max_players;
              }
            }
          });
          self.groupedSchedule = self.groupByPrice(
            availableScheduleData,
            maxPlayers
          );
        });
    },
    groupByPrice(schedule, maxPlayers) {
      let self = this;
      return schedule.reduce((rv, x) => {
        let isFree,
          isPending,
          isPaid,
          isNotPaid,
          isNeedPaid,
          isArchived,
          isEvent;
        if (x.orders) {
          isPending = x.orders.find((el) => {
            return el.status == 2;
          })
            ? true
            : false;
          isEvent = x.orders.find((el) => el.order_type === 4);

          if (isPending) {
            isFree = false;
            isPaid = false;
            isNeedPaid = false;
            isNotPaid = false;
          } else {
            isNotPaid = x.orders.find((el) => {
              return (
                el.paid == 0 &&
                el.purchase > 0 &&
                el.order_type !== 2 &&
                el.order_type !== 3
              );
            })
              ? true
              : false;

            if (isNotPaid) {
              isFree = false;
              isPaid = false;
              isNeedPaid = false;
            } else {
              isFree = x.orders.find((el) => {
                return el.order_type == 3 || el.order_type == 2;
              })
                ? true
                : false;
              isPaid = x.orders.find((el) => {
                return el.status == 6;
              })
                ? true
                : false;
              isNeedPaid = x.orders.find((el) => {
                return el.need_paid > 0 && el.paid > 0;
              })
                ? true
                : false;
            }
          }
        }

        isArchived = moment
          .parseZone(x.begin)
          .add(self.selectedPlayground.duration, "m")
          .isBefore(moment.parseZone())
          ? true
          : false;
        let price = x["pricing"]["personal_price"];
        if (price == null) {
          price = x["pricing"]["session_price"];
        } else {
          price *= maxPlayers;
        }
        (rv[price] = rv[price] || []).push(
          Object.assign(
            {
              isFree: isFree,
              isPending: isPending,
              isNotPaid: isNotPaid,
              isNeedPaid: isNeedPaid,
              isPaid: isPaid,
              isArchived: isArchived,
              isEvent: isEvent,
            },
            x
          )
        );
        return rv;
      }, {});
    },
    convertPrice(value) {
      let currency = this.location.currency;
      let price = new Intl.NumberFormat(
        navigator.language.split("-")[0]
      ).format(value);

      if (currency.is_before) {
        return currency.code + currency.blank_place + price;
      } else {
        return price + currency.blank_place + currency.code;
      }
    },
    reloadSummary() {
      this.panel = null;
      this.loadSummary({
        location_id: this.location.id,
        date: this.selectedMonth,
      });
    },
    visibleAlert() {
      this.alert = true;
    },
    closeDialog() {
      if (this.orderId !== null) {
        this.reloadSummary();
        this.dialogForm = false;
        this.dialogFormMulti = false;
      }
    },
  },

  mounted() {
    this.loadSummary({
      location_id: this.location.id,
      date: this.selectedMonth,
    });
    let previousSelectedPg =
      window.localStorage.getItem("selected_pg_id") &&
      this.location.playgrounds.find((el) => {
        return el.id == window.localStorage.getItem("selected_pg_id");
      })
        ? this.location.playgrounds.find((el) => {
            return el.id == window.localStorage.getItem("selected_pg_id");
          })
        : false;

    if (previousSelectedPg) {
      this.selectedPlayground = this.location.playgrounds.find((el) => {
        return el.id == window.localStorage.getItem("selected_pg_id");
      });
    } else {
      this.selectedPlayground = this.location.playgrounds[0];
    }
  },
};
</script>

<style>
.container-title {
  font-size: 3rem;
  font-weight: 400;
}
@media (max-width: 1163px) {
  .container-title {
    font-size: 2rem;
  }
}
</style>
